export function shuffle<T>(items: T[]): T[] {
    const result = [...items];
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
}

export function pickRandomIndices(count: number, howMany: number): number[] {
    return shuffle(Array.from({length: count}, (_, i) => i)).slice(0, howMany);
}

export function uid(): string {
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
}
